import * as React from 'react'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const ClientPreferences = React.lazy(
  () => import('modules/bookkeepers/components/ClientPreferences')
)
const CompanyPreferences = React.lazy(
  () => import('modules/bookkeepers/components/CompanyPreferences')
)
const NavigateToIncidences = React.lazy(
  () => import('modules/bookkeepers/components/NavigateToIncidences')
)
const PayrollExportsComponent = React.lazy(
  () => import('modules/bookkeepers/components/PayrollCalculations')
)
const ClosePayrollCalculation = React.lazy(
  () => import('modules/bookkeepers/components/PayrollCalculations/ClosePayrollCalculation')
)
const PayrollResults = React.lazy(() => import('modules/bookkeepers/components/PayrollDashboard'))
const RootPage = React.lazy(() => import('modules/bookkeepers/pages/RootPage'))

/*Clients*/
const ClientsPage = React.lazy(() => import('modules/bookkeepers/pages/Clients'))
const PayrollDashboard = React.lazy(
  () => import('modules/bookkeepers/pages/Clients/PayrollDashboard')
)
const PayrollExportPage = React.lazy(
  () => import('modules/bookkeepers/pages/Clients/PayrollExports')
)

const PayrollCyclesPage = React.lazy(
  () => import('modules/bookkeepers/pages/Clients/PayrollCycles')
)

/*Settings*/
const SettingsPage = React.lazy(() => import('modules/bookkeepers/pages/Settings'))
const IncidenceNoteTab = React.lazy(
  () => import('modules/bookkeepers/pages/incidences/IncidenceNoteTab')
)
const IncidenceTasksTab = React.lazy(
  () => import('modules/bookkeepers/pages/incidences/IncidenceTasksTab')
)

/*Incidences*/
const IncidencesPage = React.lazy(
  () => import('modules/bookkeepers/pages/incidences/IncidencesTable')
)
const IncidenceDetailTab = React.lazy(
  () => import('modules/payroll_bundle/pages/IncidenceDetailPage')
)
const IncidenceHistoryPage = React.lazy(
  () => import('modules/payroll_bundle/pages/IncidenceHistoryPage')
)
const IncidenceMessagePage = React.lazy(
  () => import('modules/payroll_bundle/pages/IncidenceMessagePage')
)
const PayrollExportModalWithPolicyPeriod = React.lazy(
  () => import('modules/payroll_exporter/components/PayrollExportModalWithPolicyPeriod')
)
const SyncModalWithPolicyPeriod = React.lazy(
  () => import('modules/payroll_integrations_a3innuva/components/SyncModalWithPolicyPeriod')
)

export const bookkeeperRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.bookkeepers.path,
      element: <RootPage />,
      children: [
        {
          index: true,
          element: <NavigateToIncidences />,
        },
        {
          path: navigation.bookkeepers.incidences.path,
          element: <IncidencesPage />,
          children: [
            {
              path: navigation.bookkeepers.incidences.idChanges.path,
              element: <IncidenceHistoryPage />,
            },
            {
              path: navigation.bookkeepers.incidences.details.path,
              element: <IncidenceDetailTab />,
            },
            {
              path: navigation.bookkeepers.incidences.idNotes.path,
              element: <IncidenceNoteTab />,
            },
            {
              path: navigation.bookkeepers.incidences.idMessages.path,
              element: <IncidenceMessagePage />,
            },
            {
              path: navigation.bookkeepers.incidences.idTasks.path,
              element: <IncidenceTasksTab />,
            },
          ],
        },
        {
          path: navigation.bookkeepers.clients.path,
          element: <ClientsPage />,
          children: [
            {
              path: navigation.bookkeepers.clients.payrollResults.path,
              element: <PayrollDashboard />,
              children: [
                {
                  index: true,
                  element: <PayrollResults />,
                },
                {
                  path: navigation.bookkeepers.clients.payrollResults.payrollPolicy.path,
                  element: <PayrollExportPage />,
                  children: [
                    {
                      path: navigation.bookkeepers.clients.payrollResults.payrollPolicy
                        .payrollPolicyPeriodId.path,
                      element: <PayrollExportsComponent />,
                      children: [
                        {
                          path: navigation.bookkeepers.clients.payrollResults.payrollPolicy
                            .payrollPolicyPeriodId.sync.path,
                          element: <SyncModalWithPolicyPeriod />,
                        },
                        {
                          path: navigation.bookkeepers.clients.payrollResults.payrollPolicy
                            .payrollPolicyPeriodId.export.path,
                          element: <PayrollExportModalWithPolicyPeriod />,
                        },
                        {
                          path: navigation.bookkeepers.clients.payrollResults.payrollPolicy
                            .payrollPolicyPeriodId.upload.path,
                          element: <ClosePayrollCalculation />,
                        },
                      ],
                    },
                  ],
                },
              ],
            },

            {
              path: navigation.bookkeepers.clients.preferences.path,
              element: <ClientPreferences />,
            },
            {
              path: navigation.bookkeepers.clients.payrollCycles.path,
              element: <PayrollCyclesPage />,
            },
          ],
        },
        {
          path: navigation.bookkeepers.settings.path,
          element: <SettingsPage />,
        },
        {
          path: navigation.bookkeepers.companies.path,
          element: <CompanyPreferences />,
        },
      ],
    },
  ]
}
